module.exports = __webpack_public_path__ + "static/media/2DGACM6.7df9afc0.jpg";